import { createBrowserRouter } from "react-router-dom"

import routerRoutes from "./routerRoutes.tsx"

const router = createBrowserRouter(routerRoutes)

export default router
